<template>
  <div style="padding: 16px">
    <div v-if="visible === 1">
      <StatisticsWithIcon :data="statisticsData" flex-start style="margin-bottom: 16px">
        <template #todayChannelFans-desc-slot>
          <span class="ant-text-danger" :title="selectByDeduplicationRange.todayFansTip">
            {{ selectByDeduplicationRange.todayFansTip }}
          </span>
        </template>
        <template #totalChannelFans-desc-slot>
          <span class="ant-text-danger" :title="selectByDeduplicationRange.totalFansTip">
            {{ selectByDeduplicationRange.totalFansTip }}
          </span>
        </template>
        <template #todayChannelFansRepeat-desc-slot>
          <span class="ant-text-danger" title="今日重复进粉的数据"> 今日重复进粉的数据 </span>
        </template>
        <template #totalChannelFansRepeat-desc-slot>
          <span class="ant-text-danger" title="历史重复进粉的数据"> 历史重复进粉的数据 </span>
        </template>
        <template #todayChannelFans-slot>
          <a @click="showChannelFans('todayChannelFans')">查看</a>
        </template>
        <template #totalChannelFans-slot>
          <a @click="showChannelFans('totalChannelFans')">查看</a>
        </template>
        <template #todayChannelFansRepeat-slot>
          <a @click="showChannelFans('todayChannelFansRepeat')">查看</a>
        </template>
        <template #totalChannelFansRepeat-slot>
          <a @click="showChannelFans('totalChannelFansRepeat')">查看</a>
        </template>
      </StatisticsWithIcon>
      <a-card :bordered="false" :body-style="{ padding: '16px 24px' }" style="margin: 16px 0">
        <a-descriptions :column="{ xl: 4, md: 3, sm: 2, xs: 1 }">
          <template #title>
            <h3>渠道工单信息</h3>
          </template>
          <a-descriptions-item label="渠道号">
            <span>{{ channelInfo.channelNo }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="findItem(useStatus, channelInfo.status).color">
              {{ findItem(useStatus, channelInfo.status).label }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="去重范围">
            <span style="color: #1890ff">
              {{ findItem(deduplicationRanges, channelInfo.checkBaseFan).label }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="置零时间（东八区 UTC+08:00）">
            <span style="color: #70b603">{{ channelInfo.startTime }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-card>
      <div class="ant-pro-table-search">
        <a-form :form="queryParam" v-bind="searchFormLayout" @keydown.enter.native="reloadTable">
          <a-row :gutter="16">
            <a-col :md="6" :sm="24">
              <a-form-item label="客服号">
                <a-input v-model="queryParam.whatsId" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="PC状态">
                <a-select v-model="queryParam.survivalStatus" allow-clear>
                  <a-select-option v-for="item in accountStates" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="进粉时间">
                <a-range-picker
                  v-model="queryParam.joinFanTime"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="changeJoinTime"
                />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!-- <a-col :md="6" :sm="24">
                <a-form-item label="WaChat状态">
                  <a-select v-model="queryParam.mobileOnlineStatus" allow-clear>
                    <a-select-option
                      v-for="item in accountStates"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :md="6" :sm="24">
                <a-form-item label="平台">
                  <a-select v-model="queryParam.platform" allow-clear>
                    <a-select-option v-for="item in platforms" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="昵称">
                  <a-input v-model="queryParam.nickname" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商业号">
                  <a-select v-model="queryParam.businessType" allow-clear>
                    <a-select-option v-for="item in isBusinessNumbers" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="地区">
                  <SelectCountry v-model="queryParam.countryCode" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="备注">
                  <a-input v-model="queryParam.remarks" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="创建时间">
                  <a-range-picker
                    v-model="queryParam.createTime"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="changeCreateTime"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="最近活跃时间">
                  <a-range-picker
                    v-model="queryParam.lastLoginTime"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="changeLastLoginTime"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="更新时间">
                  <a-range-picker
                    v-model="queryParam.updateTime"
                    :show-time="{
                      hideDisabledOptions: true,
                      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                    }"
                    @change="changeUpdateTime"
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="24" class="table-page-search-wrapper">
              <div class="table-page-search-submitButtons">
                <a-space>
                  <a-button type="primary" @click="reloadTable"> 查询 </a-button>
                  <a-button @click="resetSearchForm"> 重置 </a-button>
                  <a @click="toggleAdvanced">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </a-space>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-card :bordered="false" :body-style="{ padding: 0 }">
        <div class="ant-pro-table-toolbar">
          <div class="ant-pro-table-toolbar-title">
            <!-- <a-button type="primary" @click="handleAnalysis"> 分析重复 </a-button> -->
            <div class="ant-text-danger">
              <div>去重范围: {{ selectByDeduplicationRange.range }}</div>
              <div>
                总底粉库去重:
                进粉后自动加入底粉库，任何工单的进粉数据不再重复计算进粉，统一按照底粉库排重，重复进粉的算重粉。
              </div>
              <div>当前工单去重: 进粉后按照当前工单排重，未出现过的数据为新粉，重复进粉的算重粉</div>
            </div>
          </div>
          <div class="ant-pro-table-toolbar-option">
            <a-space class="ant-text-danger">
              <a-icon type="info-circle" />
              <span> 进粉时间仅用于导出号码 </span>
            </a-space>
            <a-button type="primary" :loading="exportLoading" @click="handleWhatsExport"> 导出客服号 </a-button>
            <a-button type="primary" :loading="exportLoading" @click="handleNumberExport"> 导出号码 </a-button>
          </div>
        </div>
        <a-table
          :row-key="rowKey"
          :columns="columns"
          size="middle"
          :data-source="dataSource"
          :loading="loading"
          :pagination="pagination"
          :scroll="{ x: 1200, y: tabHeight }"
          @change="handleTableChange"
        >
          <template #platform-slot="text">
            <a-tag :color="findItem(platforms, text).color">
              {{ findItem(platforms, text).label }}
            </a-tag>
          </template>
          <template #avatar-slot="text">
            <a-avatar shape="square" size="small" icon="user" :src="text" />
          </template>
          <template #businessType-slot="text">
            <span>{{ findItem(isBusinessNumbers, text).label }}</span>
          </template>
          <template #status-slot="text">
            <a-tag :color="findItem(accountStates, text).color">
              {{ findItem(accountStates, text).label }}
            </a-tag>
          </template>
          <template #opeartion-slot="text, record">
            <a-space size="middle">
              <a @click="viewContacts(record)">查看联系人</a>
              <a @click="viewLogs(record)">查看日志</a>
            </a-space>
          </template>
        </a-table>
      </a-card>
    </div>
    <!-- 查看联系人 -->
    <viewContacts v-if="visible === 2" :record="currentRow" @back-to-page="visible = 1" />
    <!-- 查看日志 -->
    <viewLog v-if="visible === 3" :record="currentRow" @back-to-page="visible = 1" />
    <!-- 分析重复 -->
    <RepeatAnalysis v-if="visible === 4" :whats-id-list="whatsIdList" @back-to-page="visible = 1" />
    <!-- 渠道进粉 -->
    <channelFansDetails v-if="visible === 5" :channel-fans-data="channelFansData" @back-to-page="visible = 1" />
  </div>
</template>

<script>
import { platforms, accountStates, isBusinessNumbers, useStatus, deduplicationRanges, findItem } from './constants'
import channelFansDetails from './channelFansDetails.vue'
import viewContacts from '@/views/Home/viewContacts.vue'
import viewLog from '@/views/Home/viewLog.vue'
import RepeatAnalysis from '@/views/Home/repeatAnalysis.vue'
import StatisticsWithIcon from '@/components/StatisticsWithIcon'
import SelectCountry from '@/components/SelectCountry'
import {
  queryWaPage,
  whatsAccountExport,
  fansCountDetailExport,
  queryTodayChannelFansCount,
  queryTotalChannelFansCount,
  queryTodayChannelFansRepeatCount,
  queryTotalChannelFansRepeatCount,
  queryTodayChannelFansPage,
  queryTotalChannelFansPage,
  queryTodayChannelFansRepeatPage,
  queryTotalChannelFansRepeatPage,
  exportChannelFans,
  exportRepeatChannelFans,
  queryChannelByShareCode
} from '@/api/home'
import { TablePageMixin } from '@/mixins'
import { exportFiles } from '@/utils/util'

export default {
  name: 'HomePage',
  components: {
    StatisticsWithIcon,
    viewContacts,
    viewLog,
    RepeatAnalysis,
    SelectCountry,
    channelFansDetails
  },
  mixins: [TablePageMixin],
  data() {
    return {
      getPage: queryWaPage,
      platforms,
      accountStates,
      isBusinessNumbers,
      useStatus,
      deduplicationRanges,
      findItem,
      // 1：当前页；2：查看联系人；3：查看日志；4：分析重复；5：渠道进粉；
      visible: 1,
      currentRow: {},
      statisticsCount: {
        todayChannelFans: 0,
        totalChannelFans: 0,
        todayChannelFansRepeat: 0,
        totalChannelFansRepeat: 0
      },
      channelFansData: {},
      channelInfo: {}
    }
  },
  computed: {
    statisticsData() {
      const { todayChannelFans, totalChannelFans, todayChannelFansRepeat, totalChannelFansRepeat } =
        this.statisticsCount
      return [
        {
          icon: require('@/assets/statistics/statistics1.png'),
          bgColor: '#e8faea',
          title: '今日进粉',
          count: todayChannelFans,
          operate: 'todayChannelFans-slot',
          desc: 'todayChannelFans-desc-slot'
        },
        {
          icon: require('@/assets/statistics/statistics2.png'),
          bgColor: '#fdf3e9',
          title: '历史进粉',
          count: totalChannelFans,
          operate: 'totalChannelFans-slot',
          desc: 'totalChannelFans-desc-slot'
        },
        {
          icon: require('@/assets/statistics/statistics11.png'),
          bgColor: '#f0f5fb',
          title: '今日重复进粉',
          count: todayChannelFansRepeat,
          operate: 'todayChannelFansRepeat-slot',
          desc: 'todayChannelFansRepeat-desc-slot'
        },
        {
          icon: require('@/assets/statistics/statistics12.png'),
          bgColor: '#e7e1fb',
          title: '历史重复进粉',
          count: totalChannelFansRepeat,
          operate: 'totalChannelFansRepeat-slot',
          desc: 'totalChannelFansRepeat-desc-slot'
        }
      ]
    },
    columns() {
      return [
        {
          title: '平台',
          dataIndex: 'platform',
          scopedSlots: { customRender: 'platform-slot' },
          align: 'center',
          width: 120
        },
        {
          title: '客服号',
          dataIndex: 'whatsId',
          align: 'center',
          width: 130
        },
        {
          title: '昵称',
          dataIndex: 'pushName',
          align: 'center',
          width: 120
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar-slot' },
          align: 'center',
          width: 100
        },
        {
          title: '地区',
          dataIndex: 'countryCode',
          align: 'center',
          width: 120
        },
        // {
        //   title: 'WaChat状态',
        //   dataIndex: 'mobileOnlineStatus',
        //   scopedSlots: { customRender: 'status-slot' },
        //   align: 'center',
        //   width: 100
        // },
        {
          title: '商业号',
          dataIndex: 'businessType',
          scopedSlots: { customRender: 'businessType-slot' },
          align: 'center',
          width: 100
        },
        {
          title: 'PC状态',
          dataIndex: 'survivalStatus',
          scopedSlots: { customRender: 'status-slot' },
          align: 'center',
          width: 100
        },
        {
          title: '联系人',
          dataIndex: 'contactsNum',
          align: 'center',
          width: 100
        },
        {
          title: '最近活跃时间',
          dataIndex: 'lastLoginTime',
          align: 'center',
          width: 150
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          align: 'center',
          width: 130,
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 150
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          align: 'center',
          width: 150
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'opeartion-slot' },
          align: 'center',
          width: 180
        }
      ]
    },
    whatsIdList() {
      return this.selectedRows.map(item => item.whatsId)
    },
    selectByDeduplicationRange() {
      const checkBaseFan = this.channelInfo.checkBaseFan
      let todayFansTip, totalFansTip, range
      switch (checkBaseFan) {
        case 1:
          todayFansTip = '今日进粉和总底粉库排重后新增的数据'
          totalFansTip = '历史进粉和总底粉库排重后新增的数据'
          range = '总底粉库去重'
          break
        case 0:
          todayFansTip = '今日进粉和当前工单排重后新增的数据'
          totalFansTip = '历史进粉和当前工单排重后新增的数据'
          range = '当前工单去重'
          break
      }
      return {
        todayFansTip,
        totalFansTip,
        range
      }
    }
  },
  mounted() {
    this.queryChannel()
    this.getStatistics()
  },
  methods: {
    // 查询当前页面的渠道工单
    queryChannel() {
      queryChannelByShareCode().then(res => {
        if (res.code === 200) {
          this.channelInfo = res.data
        }
      })
    },
    changeJoinTime(date, dateString) {
      this.queryParam.startJoinTime = dateString[0]
      this.queryParam.endJoinTime = dateString[1]
    },
    changeCreateTime(date, dateString) {
      this.queryParam.startCreateTime = dateString[0]
      this.queryParam.endCreateTime = dateString[1]
    },
    changeUpdateTime(date, dateString) {
      this.queryParam.startUpdateTime = dateString[0]
      this.queryParam.endUpdateTime = dateString[1]
    },
    changeLastLoginTime(date, dateString) {
      this.queryParam.startLastLoginTime = dateString[0]
      this.queryParam.endLastLoginTime = dateString[1]
    },
    getStatistics() {
      queryTodayChannelFansCount(this.queryParam).then(res => {
        if (res.code === 200) {
          this.statisticsCount.todayChannelFans = res.data
        }
      })
      queryTotalChannelFansCount(this.queryParam).then(res => {
        if (res.code === 200) {
          this.statisticsCount.totalChannelFans = res.data
        }
      })
      queryTodayChannelFansRepeatCount(this.queryParam).then(res => {
        if (res.code === 200) {
          this.statisticsCount.todayChannelFansRepeat = res.data
        }
      })
      queryTotalChannelFansRepeatCount(this.queryParam).then(res => {
        if (res.code === 200) {
          this.statisticsCount.totalChannelFansRepeat = res.data
        }
      })
    },
    // 查看联系人
    viewContacts(record) {
      this.visible = 2
      this.currentRow = record
    },
    // 查看日志
    viewLogs(record) {
      this.visible = 3
      this.currentRow = record
    },
    // 分析重复
    handleAnalysis() {
      if (!this.selectedRowKeys.length) {
        return this.$message.info('请选择列表')
      }
      this.visible = 4
    },
    handleWhatsExport() {
      this.exportLoading = true
      exportFiles({
        request: whatsAccountExport,
        queryParam: this.queryParam,
        callback: () => {
          this.exportLoading = false
        }
      })
    },
    handleNumberExport() {
      this.exportLoading = true
      exportFiles({
        request: fansCountDetailExport,
        queryParam: this.queryParam,
        callback: () => {
          this.exportLoading = false
        }
      })
    },
    showChannelFans(key) {
      this.visible = 5
      this.channelFansData = {}
      const resetTime = this.moment().format(`YYYY-MM-DD ${this.channelInfo.startTime}`)
      const currentTime = this.moment().format(`YYYY-MM-DD HH:mm:ss`)
      // 重置时间是否过期，在当前时间之前
      const isExpired = this.moment(resetTime).isBefore(currentTime)
      let startCreateTime
      let endCreateTime
      if (isExpired) {
        // 如果在当前时间之前，则开始时间为今天，结束时间为明天
        startCreateTime = resetTime
        endCreateTime = this.moment().add(1, 'days').format(`YYYY-MM-DD ${this.channelInfo.startTime}`)
      } else {
        // 如果在当前时间之后，则开始时间为昨天，结束时间为今天
        startCreateTime = this.moment().subtract(1, 'days').format(`YYYY-MM-DD ${this.channelInfo.startTime}`)
        endCreateTime = resetTime
      }
      if (key === 'todayChannelFans') {
        this.channelFansData = {
          ...this.channelFansData,
          title: '今日进粉',
          getPage: queryTodayChannelFansPage,
          exportFunction: exportChannelFans,
          exportParams: {
            startCreateTime: startCreateTime,
            endCreateTime: endCreateTime
          }
        }
      } else if (key === 'totalChannelFans') {
        this.channelFansData = {
          ...this.channelFansData,
          title: '历史进粉',
          getPage: queryTotalChannelFansPage,
          exportFunction: exportChannelFans
        }
      } else if (key === 'todayChannelFansRepeat') {
        this.channelFansData = {
          ...this.channelFansData,
          title: '今日重复进粉',
          getPage: queryTodayChannelFansRepeatPage,
          exportFunction: exportRepeatChannelFans,
          exportParams: {
            startCreateTime: startCreateTime,
            endCreateTime: endCreateTime
          }
        }
      } else if (key === 'totalChannelFansRepeat') {
        this.channelFansData = {
          ...this.channelFansData,
          title: '历史重复进粉',
          getPage: queryTotalChannelFansRepeatPage,
          exportFunction: exportRepeatChannelFans
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ant-tag {
  margin-right: 0;
}
</style>
